<template>
  <cc-container class="invoice">
    <cc-header-nav title="发票预览" url="#/invoice/list" >
    </cc-header-nav>
     <cc-main>
      <div id="demo"></div>
     </cc-main>
  </cc-container>
</template>
<script>
import Pdfh5 from 'pdfh5'

export default {
  name: 'App',
  data () {
    return {
      pdfh5: null,
      src: '',
      title: ''
    }
  },
  created () {
    this.title = this.$route.query.url
  },
  mounted () {
    // 实例化
    this.pdfh5 = new Pdfh5('#demo', {
      pdfurl: this.$route.query.url,
      renderType: 'canvas',
      cMapUrl: 'https://unpkg.com/pdfjs-dist@1.9.426/cmaps/'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/index.scss";
</style>
